export default function getUrl(path, filter) {
  const searchParams = new URLSearchParams(filter).toString();

  const query = `${path}${searchParams}`;
  return query;
}
